import { SankeyLink } from '../types/sankey';

export const TIC3: SankeyLink[] = [
    {
        source: 101,
        target: 15,
        value: 1,
        valueid: ['repb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_4',
        id: 'CGK21-5',
        imgUrl: 'Q201xEJ.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 101,
        target: 16,
        value: 1,
        valueid: ['repb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_6',
        id: 'CGK21-7',
        imgUrl: 'Q201xEJ.jpg',
        cluster: 'tic3',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 101,
        target: 16,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_7',
        id: 'CGK21-8',
        imgUrl: 'Q201xEJ.jpg',
        cluster: 'tic3',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 15, target: 41, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_4', id: 'CGK21-15', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 16, target: 41, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_6', id: 'CGK21-17', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 16, target: 41, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-18', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 54, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_4', id: 'CGK21-23', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 54, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_6', id: 'CGK21-24', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 59, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-25', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 54, target: 77, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_4', id: 'CGK21-29', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 54, target: 77, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_6', id: 'CGK21-30', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 54, target: 78, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_4', id: 'CGK21-35', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 54, target: 78, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_6', id: 'CGK21-36', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 59, target: 79, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-41', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 54, target: 87, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_4', id: 'CGK21-43', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 54, target: 87, value: 1, valueid: ['repb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_6', id: 'CGK21-44', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 59, target: 95, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_7', id: 'CGK21-47', imgUrl: 'Q201xEJ.jpg', cluster: 'tic3', color: 'repVisTechColor' },

    {
        source: 15,
        target: 41,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-4',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 18,
        target: 41,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-8',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 41,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-12',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 41,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-13',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    { source: 52, target: 77, value: 1, valueid: ['targetcb', 'targetaa'], paperName: 'EAIA17', process: 'EAIA17_1', id: 'EAIA17-20', imgUrl: 'TFuj7MS.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 52, target: 79, value: 1, valueid: ['targetcb', 'targetaa'], paperName: 'EAIA17', process: 'EAIA17_1', id: 'EAIA17-22', imgUrl: 'TFuj7MS.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 52, target: 79, value: 1, valueid: ['targetcb', 'targetaa'], paperName: 'EAIA17', process: 'EAIA17_3', id: 'EAIA17-23', imgUrl: 'TFuj7MS.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 52, target: 81, value: 1, valueid: ['targetcb', 'targetaa'], paperName: 'EAIA17', process: 'EAIA17_1', id: 'EAIA17-24', imgUrl: 'TFuj7MS.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 110,
        target: 11,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-0',
        imgUrl: 'TIajUJa.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 110,
        target: 12,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-1',
        imgUrl: 'TIajUJa.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 41,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-8',
        imgUrl: 'TIajUJa.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 12,
        target: 41,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-9',
        imgUrl: 'TIajUJa.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 41,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-15',
        imgUrl: 'TIajUJa.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 60,
        target: 80,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-17',
        imgUrl: 'TIajUJa.jpg',
        cluster: 'tic3',
        color: 'repVisVarColor',
    },
    {
        source: 60,
        target: 77,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-18',
        imgUrl: 'TIajUJa.jpg',
        cluster: 'tic3',
        color: 'repVisVarColor',
    },
    {
        source: 60,
        target: 92,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-19',
        imgUrl: 'TIajUJa.jpg',
        cluster: 'tic3',
        color: 'repVisTechColor',
    },
    {
        source: 114,
        target: 11,
        value: 1,
        valueid: 'repd',
        paperName: 'KSBK15',
        process: 'KSBK15_4',
        id: 'KSBK15-21',
        imgUrl: 'AY0EaHs.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 13,
        value: 1,
        valueid: 'repd',
        paperName: 'KSBK15',
        process: 'KSBK15_4',
        id: 'KSBK15-22',
        imgUrl: 'AY0EaHs.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 15,
        value: 1,
        valueid: 'repd',
        paperName: 'KSBK15',
        process: 'KSBK15_4',
        id: 'KSBK15-23',
        imgUrl: 'AY0EaHs.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 11,
        value: 1,
        valueid: 'repf',
        paperName: 'KSBK15',
        process: 'KSBK15_5',
        id: 'KSBK15-24',
        imgUrl: 'AY0EaHs.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 13,
        value: 1,
        valueid: 'repf',
        paperName: 'KSBK15',
        process: 'KSBK15_5',
        id: 'KSBK15-25',
        imgUrl: 'AY0EaHs.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 15,
        value: 1,
        valueid: 'repf',
        paperName: 'KSBK15',
        process: 'KSBK15_5',
        id: 'KSBK15-26',
        imgUrl: 'AY0EaHs.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 16,
        value: 1,
        valueid: 'repf',
        paperName: 'KSBK15',
        process: 'KSBK15_7',
        id: 'KSBK15-30',
        imgUrl: 'AY0EaHs.png',
        cluster: 'tic3',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 11, target: 41, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-59', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 13, target: 41, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-60', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 15, target: 41, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-61', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 11, target: 41, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-62', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 13, target: 41, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-63', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 15, target: 41, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-64', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 16, target: 41, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_7', id: 'KSBK15-77', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 55, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-85', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 60, value: 1, valueid: 'repf', paperName: 'KSBK15', process: 'KSBK15_5', id: 'KSBK15-86', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 55, target: 84, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-94', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 55, target: 85, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-96', imgUrl: 'AY0EaHs.png', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 128,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-2',
        imgUrl: 'h29usSh.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 41,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-24',
        imgUrl: 'h29usSh.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 41,
        target: 54,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-25',
        imgUrl: 'h29usSh.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 54,
        target: 81,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-26',
        imgUrl: 'h29usSh.jpg',
        cluster: 'tic3',
        color: 'repVisVarColor',
    },
    {
        source: 54,
        target: 84,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-27',
        imgUrl: 'h29usSh.jpg',
        cluster: 'tic3',
        color: 'repVisTechColor',
    },
    {
        source: 133,
        target: 15,
        value: 1,
        valueid: 'targetba',
        paperName: 'XWL17',
        process: 'XWL17_3',
        id: 'XWL17-3',
        imgUrl: 'VqSzaXU.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 15, target: 41, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_3', id: 'XWL17-7', imgUrl: 'VqSzaXU.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 61, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_3', id: 'XWL17-10', imgUrl: 'VqSzaXU.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 61, target: 77, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_3', id: 'XWL17-16', imgUrl: 'VqSzaXU.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 143,
        target: 12,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-0',
        imgUrl: 'yya8s2u.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 14,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-1',
        imgUrl: 'yya8s2u.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 15,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-2',
        imgUrl: 'yya8s2u.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 12, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-11', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 14, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-12', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 15, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-13', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 61, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-14', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 61, target: 84, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-15', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 61, target: 86, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-16', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 61, target: 92, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-17', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 151,
        target: 11,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-0',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 151,
        target: 12,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-1',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 151,
        target: 13,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-2',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 151,
        target: 14,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-3',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 151,
        target: 15,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-4',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 151,
        target: 16,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_2',
        id: 'FA20-5',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 41,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-11',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 12,
        target: 41,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-12',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 13,
        target: 41,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-13',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 14,
        target: 41,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-14',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 15,
        target: 41,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-15',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 16,
        target: 41,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_2',
        id: 'FA20-16',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 41,
        target: 59,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-17',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 41,
        target: 59,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_2',
        id: 'FA20-18',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'intThreeLinkColor',
    },
    {
        source: 59,
        target: 77,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_1',
        id: 'FA20-20',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'repVisVarColor',
    },
    {
        source: 59,
        target: 77,
        value: 1,
        valueid: ['repea', 'targetba', 'targetbb'],
        paperName: 'FA20',
        process: 'FA20_2',
        id: 'FA20-21',
        imgUrl: '2VPQbry.jpg',
        cluster: 'tic3',
        color: 'repVisVarColor',
    },

    {
        source: 152,
        target: 6,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_1',
        id: 'WHWS12-2',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 0,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-3',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 3,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-4',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 6,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-5',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },

    { source: 0, target: 41, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-15', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 3, target: 41, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-18', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 6, target: 41, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-21', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 60, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-24', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },

    { source: 0, target: 41, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-31', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 3, target: 41, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-32', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 6, target: 41, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-33', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 68, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-38', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 68, target: 76, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-40', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 68, target: 77, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-41', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 68, target: 78, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-42', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 11, target: 41, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-58', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 68, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-62', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },

    { source: 11, target: 41, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-69', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 59, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-72', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },

    {
        source: 159,
        target: 15,
        value: 1,
        valueid: 'repea',
        paperName: 'ASG21',
        process: 'ASG21_1',
        id: 'ASG21-0',
        imgUrl: 'JY2gfvN.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 15, target: 41, value: 1, valueid: 'repea', paperName: 'ASG21', process: 'ASG21_1', id: 'ASG21-5', imgUrl: 'JY2gfvN.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 41, target: 59, value: 1, valueid: 'repea', paperName: 'ASG21', process: 'ASG21_1', id: 'ASG21-6', imgUrl: 'JY2gfvN.jpg', cluster: 'tic3', color: 'intThreeLinkColor' },
    { source: 59, target: 77, value: 1, valueid: 'repea', paperName: 'ASG21', process: 'ASG21_1', id: 'ASG21-7', imgUrl: 'JY2gfvN.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 59, target: 78, value: 1, valueid: 'repea', paperName: 'ASG21', process: 'ASG21_1', id: 'ASG21-8', imgUrl: 'JY2gfvN.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 100,
        target: 11,
        value: 1,
        valueid: ['repeb', 'targetaa'],
        paperName: 'CAA20',
        process: 'CAA20_3',
        id: 'CAA20-2',
        imgUrl: 'DFBi3Mo.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_3', id: 'CAA20-9', imgUrl: 'DFBi3Mo.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 59, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_3', id: 'CAA20-16', imgUrl: 'DFBi3Mo.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 59, target: 77, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_3', id: 'CAA20-22', imgUrl: 'DFBi3Mo.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 59, target: 78, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_3', id: 'CAA20-23', imgUrl: 'DFBi3Mo.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 59, target: 92, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_3', id: 'CAA20-29', imgUrl: 'DFBi3Mo.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 105,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_4',
        id: 'EYG15-3',
        imgUrl: '9p9Vu7Y.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 105,
        target: 16,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_5',
        id: 'EYG15-4',
        imgUrl: '9p9Vu7Y.jpg',
        cluster: 'tic3',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 63,
        target: 77,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_4',
        id: 'EYG15-13',
        imgUrl: '9p9Vu7Y.jpg',
        cluster: 'tic3',
        color: 'repVisVarColor',
    },
    {
        source: 11,
        target: 39,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_4',
        id: 'EYG15-17',
        imgUrl: '9p9Vu7Y.jpg',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 39,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_4',
        id: 'EYG15-19',
        imgUrl: '9p9Vu7Y.jpg',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 39,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_5',
        id: 'EYG15-20',
        imgUrl: '9p9Vu7Y.jpg',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 63,
        target: 92,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_4',
        id: 'EYG15-24',
        imgUrl: '9p9Vu7Y.jpg',
        cluster: 'tic3',
        color: 'repVisTechColor',
    },
    {
        source: 16,
        target: 39,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_5',
        id: 'EYG15-25',
        imgUrl: '9p9Vu7Y.jpg',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 63,
        target: 84,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_5',
        id: 'EYG15-27',
        imgUrl: '9p9Vu7Y.jpg',
        cluster: 'tic3',
        color: 'repVisTechColor',
    },
    {
        source: 112,
        target: 11,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-2',
        imgUrl: 'n4jwcKO.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 112,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-3',
        imgUrl: 'n4jwcKO.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-9', imgUrl: 'n4jwcKO.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 12, target: 39, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-13', imgUrl: 'n4jwcKO.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-19', imgUrl: 'n4jwcKO.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 53, target: 77, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-25', imgUrl: 'n4jwcKO.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 78, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-27', imgUrl: 'n4jwcKO.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 80, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-29', imgUrl: 'n4jwcKO.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 116,
        target: 11,
        value: 1,
        valueid: 'repb',
        paperName: 'LJC18',
        process: 'LJC18_5',
        id: 'LJC18-4',
        imgUrl: 'bYdgkcY.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_5', id: 'LJC18-11', imgUrl: 'bYdgkcY.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 54, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_5', id: 'LJC18-20', imgUrl: 'bYdgkcY.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 54, target: 77, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_5', id: 'LJC18-30', imgUrl: 'bYdgkcY.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 54, target: 92, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_5', id: 'LJC18-36', imgUrl: 'bYdgkcY.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 119,
        target: 11,
        value: 1,
        valueid: 'targetca',
        paperName: 'MA16',
        process: 'MA16_1',
        id: 'MA16-0',
        imgUrl: '69BWuDV.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 119,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repg'],
        paperName: 'MA16',
        process: 'MA16_2',
        id: 'MA16-1',
        imgUrl: '69BWuDV.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_1', id: 'MA16-6', imgUrl: '69BWuDV.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 11, target: 39, value: 1, valueid: ['targetca', 'repg'], paperName: 'MA16', process: 'MA16_2', id: 'MA16-7', imgUrl: '69BWuDV.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 67, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_1', id: 'MA16-12', imgUrl: '69BWuDV.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 68, value: 1, valueid: ['targetca', 'repg'], paperName: 'MA16', process: 'MA16_2', id: 'MA16-13', imgUrl: '69BWuDV.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 68, target: 77, value: 1, valueid: ['targetca', 'repg'], paperName: 'MA16', process: 'MA16_2', id: 'MA16-18', imgUrl: '69BWuDV.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 67, target: 83, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_1', id: 'MA16-20', imgUrl: '69BWuDV.png', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 67, target: 92, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_1', id: 'MA16-21', imgUrl: '69BWuDV.png', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 120,
        target: 7,
        value: 1,
        valueid: ['targetca', 'repb'],
        paperName: 'MDD10',
        process: 'MDD10_1',
        id: 'MDD10-0',
        imgUrl: 'AA3ZOvl.png',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 120,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repb'],
        paperName: 'MDD10',
        process: 'MDD10_2',
        id: 'MDD10-1',
        imgUrl: 'AA3ZOvl.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 7, target: 39, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-7', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 11, target: 39, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-10', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 54, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-13', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 54, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-14', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 54, target: 77, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-17', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 54, target: 77, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-18', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 54, target: 78, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-19', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 54, target: 78, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-20', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 54, target: 86, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-22', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 54, target: 86, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-23', imgUrl: 'AA3ZOvl.png', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 122,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-0',
        imgUrl: 'Ak8KSur.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 122,
        target: 12,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-1',
        imgUrl: 'Ak8KSur.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-2', imgUrl: 'Ak8KSur.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 12, target: 39, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-3', imgUrl: 'Ak8KSur.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-8', imgUrl: 'Ak8KSur.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 53, target: 76, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-11', imgUrl: 'Ak8KSur.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 77, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-12', imgUrl: 'Ak8KSur.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 78, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-13', imgUrl: 'Ak8KSur.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 80, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-14', imgUrl: 'Ak8KSur.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 84, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-15', imgUrl: 'Ak8KSur.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 130, target: 1, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-0', imgUrl: 'chAdr4B.png', cluster: 'tic3', color: 'targetLinkColor', status: 'selected' },
    { source: 130, target: 3, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-1', imgUrl: 'chAdr4B.png', cluster: 'tic3', color: 'targetLinkColor', status: 'selected' },
    {
        source: 130,
        target: 11,
        value: 1,
        valueid: 'repf',
        paperName: 'SSK12',
        process: 'SSK12_1',
        id: 'SSK12-2',
        imgUrl: 'chAdr4B.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 130,
        target: 13,
        value: 1,
        valueid: 'repf',
        paperName: 'SSK12',
        process: 'SSK12_1',
        id: 'SSK12-3',
        imgUrl: 'chAdr4B.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 1, target: 39, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-6', imgUrl: 'chAdr4B.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 3, target: 39, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-7', imgUrl: 'chAdr4B.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 11, target: 39, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-8', imgUrl: 'chAdr4B.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 13, target: 39, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-9', imgUrl: 'chAdr4B.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 60, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-10', imgUrl: 'chAdr4B.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 60, target: 78, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-11', imgUrl: 'chAdr4B.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 60, target: 85, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-12', imgUrl: 'chAdr4B.png', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'XWS16',
        process: 'XWS16_1',
        id: 'XWS16-2',
        imgUrl: 'xn5MqwV.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-8', imgUrl: 'xn5MqwV.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-16', imgUrl: 'xn5MqwV.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 55, target: 85, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-31', imgUrl: 'xn5MqwV.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 55, target: 92, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-35', imgUrl: 'xn5MqwV.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 138,
        target: 11,
        value: 1,
        valueid: ['repd ', 'targetca'],
        paperName: 'SRJ13',
        process: 'SRJ13_1',
        id: 'SRJ13-0',
        imgUrl: 'kgWl7nV.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['repd ', 'targetca'], paperName: 'SRJ13', process: 'SRJ13_1', id: 'SRJ13-4', imgUrl: 'kgWl7nV.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 55, value: 1, valueid: ['repd ', 'targetca'], paperName: 'SRJ13', process: 'SRJ13_1', id: 'SRJ13-8', imgUrl: 'kgWl7nV.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 55, target: 79, value: 1, valueid: ['repd ', 'targetca'], paperName: 'SRJ13', process: 'SRJ13_1', id: 'SRJ13-11', imgUrl: 'kgWl7nV.png', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 141,
        target: 11,
        value: 1,
        valueid: ['targetba', 'targetbb', 'reph'],
        paperName: 'YSK14',
        process: 'YSK14_2',
        id: 'YSK14-0',
        imgUrl: 'sBwMjs9.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 141,
        target: 11,
        value: 1,
        valueid: ['targetba', 'targetbb', 'repb'],
        paperName: 'YSK14',
        process: 'YSK14_1',
        id: 'YSK14-1',
        imgUrl: 'sBwMjs9.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 39,
        value: 1,
        valueid: ['targetba', 'targetbb', 'reph'],
        paperName: 'YSK14',
        process: 'YSK14_2',
        id: 'YSK14-7',
        imgUrl: 'sBwMjs9.png',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 11,
        target: 39,
        value: 1,
        valueid: ['targetba', 'targetbb', 'repb'],
        paperName: 'YSK14',
        process: 'YSK14_1',
        id: 'YSK14-8',
        imgUrl: 'sBwMjs9.png',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 39,
        target: 54,
        value: 1,
        valueid: ['targetba', 'targetbb', 'repb'],
        paperName: 'YSK14',
        process: 'YSK14_1',
        id: 'YSK14-14',
        imgUrl: 'sBwMjs9.png',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 39,
        target: 62,
        value: 1,
        valueid: ['targetba', 'targetbb', 'reph'],
        paperName: 'YSK14',
        process: 'YSK14_2',
        id: 'YSK14-15',
        imgUrl: 'sBwMjs9.png',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 54,
        target: 78,
        value: 1,
        valueid: ['targetba', 'targetbb', 'repb'],
        paperName: 'YSK14',
        process: 'YSK14_1',
        id: 'YSK14-21',
        imgUrl: 'sBwMjs9.png',
        cluster: 'tic3',
        color: 'repVisVarColor',
    },
    {
        source: 62,
        target: 77,
        value: 1,
        valueid: ['targetba', 'targetbb', 'reph'],
        paperName: 'YSK14',
        process: 'YSK14_2',
        id: 'YSK14-26',
        imgUrl: 'sBwMjs9.png',
        cluster: 'tic3',
        color: 'repVisVarColor',
    },
    {
        source: 54,
        target: 84,
        value: 1,
        valueid: ['targetba', 'targetbb', 'repb'],
        paperName: 'YSK14',
        process: 'YSK14_1',
        id: 'YSK14-27',
        imgUrl: 'sBwMjs9.png',
        cluster: 'tic3',
        color: 'repVisTechColor',
    },
    {
        source: 142,
        target: 11,
        value: 1,
        valueid: 'repd',
        paperName: 'CSL16',
        process: 'CSL16_1',
        id: 'CSL16-0',
        imgUrl: 'mt871Nx.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 142,
        target: 11,
        value: 1,
        valueid: 'reph',
        paperName: 'CSL16',
        process: 'CSL16_2',
        id: 'CSL16-1',
        imgUrl: 'mt871Nx.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_1', id: 'CSL16-9', imgUrl: 'mt871Nx.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 55, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_1', id: 'CSL16-10', imgUrl: 'mt871Nx.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 55, target: 77, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_1', id: 'CSL16-11', imgUrl: 'mt871Nx.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 55, target: 85, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_1', id: 'CSL16-12', imgUrl: 'mt871Nx.png', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 11, target: 39, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-13', imgUrl: 'mt871Nx.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 62, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-14', imgUrl: 'mt871Nx.png', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 62, target: 79, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-15', imgUrl: 'mt871Nx.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 62, target: 88, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-16', imgUrl: 'mt871Nx.png', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 146,
        target: 7,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-0',
        imgUrl: 'r9tEkOr.jpg',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 146,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-1',
        imgUrl: 'r9tEkOr.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 7,
        target: 39,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-9',
        imgUrl: 'r9tEkOr.jpg',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 11,
        target: 39,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-10',
        imgUrl: 'r9tEkOr.jpg',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 39,
        target: 54,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-17',
        imgUrl: 'r9tEkOr.jpg',
        cluster: 'tic3',
        color: 'intTwoLinkColor',
    },
    {
        source: 54,
        target: 92,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-42',
        imgUrl: 'r9tEkOr.jpg',
        cluster: 'tic3',
        color: 'repVisTechColor',
    },
    {
        source: 150,
        target: 6,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_1',
        id: 'MLG06-0',
        imgUrl: 'qXOBST8.jpg',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },

    { source: 6, target: 39, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-2', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 12, target: 39, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-3', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-6', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-7', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },

    { source: 53, target: 76, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-11', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'repVisVarColor' },

    { source: 53, target: 77, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-13', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'repVisVarColor' },

    { source: 53, target: 78, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-15', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'repVisVarColor' },

    { source: 53, target: 82, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-17', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'repVisVarColor' },

    {
        source: 152,
        target: 11,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_5',
        id: 'WHWS12-12',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 11,
        value: 1,
        valueid: ['repea', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_6',
        id: 'WHWS12-13',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 0, target: 39, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-14', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 3, target: 39, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-17', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 6, target: 39, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-20', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 60, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-23', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },

    { source: 0, target: 39, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-28', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 3, target: 39, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-29', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 6, target: 39, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-30', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 68, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_2', id: 'WHWS12-37', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },

    { source: 11, target: 39, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-57', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 68, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-61', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 68, target: 76, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-65', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 68, target: 77, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-66', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 68, target: 78, value: 1, valueid: ['repg', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_5', id: 'WHWS12-67', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 11, target: 39, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-68', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 59, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-71', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },

    {
        source: 155,
        target: 13,
        value: 1,
        valueid: ['targetca', 'repd'],
        paperName: 'DJM12',
        process: 'DJM12_7',
        id: 'DJM12-6',
        imgUrl: 'nNNbNas.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 13, target: 39, value: 1, valueid: ['targetca', 'repd'], paperName: 'DJM12', process: 'DJM12_7', id: 'DJM12-15', imgUrl: 'nNNbNas.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 62, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_6', id: 'DJM12-24', imgUrl: 'nNNbNas.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 55, value: 1, valueid: ['targetca', 'repd'], paperName: 'DJM12', process: 'DJM12_7', id: 'DJM12-25', imgUrl: 'nNNbNas.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 62, target: 92, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_6', id: 'DJM12-29', imgUrl: 'nNNbNas.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 55, target: 77, value: 1, valueid: ['targetca', 'repd'], paperName: 'DJM12', process: 'DJM12_7', id: 'DJM12-34', imgUrl: 'nNNbNas.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 55, target: 78, value: 1, valueid: ['targetca', 'repd'], paperName: 'DJM12', process: 'DJM12_7', id: 'DJM12-35', imgUrl: 'nNNbNas.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 158,
        target: 5,
        value: 1,
        valueid: 'targetbb',
        paperName: 'XJX21',
        process: 'XJX21_3',
        id: 'XJX21-5',
        imgUrl: 'fv9Lvcx.jpg',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 158,
        target: 12,
        value: 1,
        valueid: 'targetbb',
        paperName: 'XJX21',
        process: 'XJX21_3',
        id: 'XJX21-6',
        imgUrl: 'fv9Lvcx.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 5, target: 39, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-36', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 12, target: 39, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-38', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 69, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-40', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 39, target: 71, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-41', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'intTwoLinkColor' },
    { source: 69, target: 77, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-42', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 69, target: 78, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-43', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 69, target: 92, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-44', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    { source: 71, target: 77, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-45', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 71, target: 78, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-46', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 71, target: 92, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-47', imgUrl: 'fv9Lvcx.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 103,
        target: 11,
        value: 1,
        valueid: 'targetba',
        paperName: 'DMC09',
        process: 'DMC09_2',
        id: 'DMC09-1',
        imgUrl: 'KTkfwLw.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 42, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_2', id: 'DMC09-3', imgUrl: 'KTkfwLw.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 42, target: 58, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_2', id: 'DMC09-5', imgUrl: 'KTkfwLw.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 58, target: 76, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_2', id: 'DMC09-7', imgUrl: 'KTkfwLw.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 58, target: 77, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_2', id: 'DMC09-9', imgUrl: 'KTkfwLw.png', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 104,
        target: 15,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-0',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 104,
        target: 18,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-2',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 15,
        target: 42,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-5',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 18,
        target: 42,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-9',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_1',
        id: 'EAIA17-14',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 52,
        value: 1,
        valueid: ['targetcb', 'targetaa'],
        paperName: 'EAIA17',
        process: 'EAIA17_3',
        id: 'EAIA17-15',
        imgUrl: 'TFuj7MS.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },

    {
        source: 106,
        target: 5,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-3',
        imgUrl: 'FfzA9S4.png',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 106,
        target: 17,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-4',
        imgUrl: 'FfzA9S4.png',
        cluster: 'tic3',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 106,
        target: 18,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-5',
        imgUrl: 'FfzA9S4.png',
        cluster: 'tic3',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 5, target: 42, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_2', id: 'FCF09-11', imgUrl: 'FfzA9S4.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    {
        source: 17,
        target: 42,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-14',
        imgUrl: 'FfzA9S4.png',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 18,
        target: 42,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-17',
        imgUrl: 'FfzA9S4.png',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 62,
        value: 1,
        valueid: ['targetbb', 'reph'],
        paperName: 'FCF09',
        process: 'FCF09_2',
        id: 'FCF09-21',
        imgUrl: 'FfzA9S4.png',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    { source: 62, target: 77, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_2', id: 'FCF09-25', imgUrl: 'FfzA9S4.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 62, target: 80, value: 1, valueid: ['targetbb', 'reph'], paperName: 'FCF09', process: 'FCF09_2', id: 'FCF09-29', imgUrl: 'FfzA9S4.png', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 107,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'GGS12MT',
        process: 'GGS12MT_2',
        id: 'GGS12MT-2',
        imgUrl: 'wVHfoIB.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 12,
        target: 42,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'GGS12MT',
        process: 'GGS12MT_2',
        id: 'GGS12MT-7',
        imgUrl: 'wVHfoIB.png',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 53,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'GGS12MT',
        process: 'GGS12MT_2',
        id: 'GGS12MT-12',
        imgUrl: 'wVHfoIB.png',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    { source: 53, target: 77, value: 1, valueid: ['targetbb', 'repc'], paperName: 'GGS12MT', process: 'GGS12MT_2', id: 'GGS12MT-17', imgUrl: 'wVHfoIB.png', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 108,
        target: 12,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_2',
        id: 'GGS12ST-1',
        imgUrl: 'HV2lNkC.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 12,
        target: 42,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_2',
        id: 'GGS12ST-4',
        imgUrl: 'HV2lNkC.png',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 59,
        value: 1,
        valueid: ['repeb', 'targetbb'],
        paperName: 'GGS12ST',
        process: 'GGS12ST_2',
        id: 'GGS12ST-8',
        imgUrl: 'HV2lNkC.png',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    { source: 59, target: 77, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'GGS12ST', process: 'GGS12ST_2', id: 'GGS12ST-13', imgUrl: 'HV2lNkC.png', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 109,
        target: 12,
        value: 1,
        valueid: 'targetbb',
        paperName: 'GGS12TPS',
        process: 'GGS12TPS_1',
        id: 'GGS12TPS-0',
        imgUrl: 'au5KByH.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 12, target: 42, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_1', id: 'GGS12TPS-3', imgUrl: 'au5KByH.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 42, target: 64, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_1', id: 'GGS12TPS-6', imgUrl: 'au5KByH.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 64, target: 77, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_1', id: 'GGS12TPS-9', imgUrl: 'au5KByH.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 64, target: 79, value: 1, valueid: 'targetbb', paperName: 'GGS12TPS', process: 'GGS12TPS_1', id: 'GGS12TPS-10', imgUrl: 'au5KByH.png', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 112,
        target: 11,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-2',
        imgUrl: 'n4jwcKO.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 112,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-3',
        imgUrl: 'n4jwcKO.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-10',
        imgUrl: 'n4jwcKO.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 12,
        target: 42,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-14',
        imgUrl: 'n4jwcKO.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 53,
        value: 1,
        valueid: ['targetbb', 'repc'],
        paperName: 'JSM16',
        process: 'JSM16_2',
        id: 'JSM16-20',
        imgUrl: 'n4jwcKO.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    { source: 53, target: 77, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-25', imgUrl: 'n4jwcKO.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 78, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-27', imgUrl: 'n4jwcKO.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 80, value: 1, valueid: ['targetbb', 'repc'], paperName: 'JSM16', process: 'JSM16_2', id: 'JSM16-29', imgUrl: 'n4jwcKO.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 113,
        target: 11,
        value: 1,
        valueid: ['targetba', 'targetbb'],
        paperName: 'JX17',
        process: 'JX17_5',
        id: 'JX17-7',
        imgUrl: 'dbYhmdg.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['targetba', 'targetbb'],
        paperName: 'JX17',
        process: 'JX17_5',
        id: 'JX17-17',
        imgUrl: 'dbYhmdg.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 65,
        value: 1,
        valueid: ['targetba', 'targetbb'],
        paperName: 'JX17',
        process: 'JX17_5',
        id: 'JX17-24',
        imgUrl: 'dbYhmdg.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    { source: 65, target: 77, value: 1, valueid: ['targetba', 'targetbb'], paperName: 'JX17', process: 'JX17_5', id: 'JX17-35', imgUrl: 'dbYhmdg.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 137,
        target: 7,
        value: 1,
        valueid: 'targetca',
        paperName: 'ZLW13',
        process: 'ZLW13_1',
        id: 'ZLW13-0',
        imgUrl: 'KvCmzam.png',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 137,
        target: 11,
        value: 1,
        valueid: 'targetca',
        paperName: 'ZLW13',
        process: 'ZLW13_1',
        id: 'ZLW13-1',
        imgUrl: 'KvCmzam.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 7, target: 42, value: 1, valueid: 'targetca', paperName: 'ZLW13', process: 'ZLW13_1', id: 'ZLW13-3', imgUrl: 'KvCmzam.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 11, target: 42, value: 1, valueid: 'targetca', paperName: 'ZLW13', process: 'ZLW13_1', id: 'ZLW13-4', imgUrl: 'KvCmzam.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 42, target: 55, value: 1, valueid: 'targetca', paperName: 'ZLW13', process: 'ZLW13_1', id: 'ZLW13-5', imgUrl: 'KvCmzam.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 55, target: 77, value: 1, valueid: 'targetca', paperName: 'ZLW13', process: 'ZLW13_1', id: 'ZLW13-7', imgUrl: 'KvCmzam.png', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 55, target: 80, value: 1, valueid: 'targetca', paperName: 'ZLW13', process: 'ZLW13_1', id: 'ZLW13-8', imgUrl: 'KvCmzam.png', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 140,
        target: 15,
        value: 1,
        valueid: ['repf', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_1',
        id: 'FAKM15-0',
        imgUrl: 'u2sWSNe.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 15,
        target: 42,
        value: 1,
        valueid: ['repf', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_1',
        id: 'FAKM15-1',
        imgUrl: 'u2sWSNe.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 60,
        value: 1,
        valueid: ['repf', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_1',
        id: 'FAKM15-3',
        imgUrl: 'u2sWSNe.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    { source: 60, target: 76, value: 1, valueid: ['repf', ' targetca'], paperName: 'FAKM15', process: 'FAKM15_1', id: 'FAKM15-5', imgUrl: 'u2sWSNe.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 60, target: 77, value: 1, valueid: ['repf', ' targetca'], paperName: 'FAKM15', process: 'FAKM15_1', id: 'FAKM15-6', imgUrl: 'u2sWSNe.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 143,
        target: 12,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_2',
        id: 'RRR19-3',
        imgUrl: 'yya8s2u.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 14,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_2',
        id: 'RRR19-4',
        imgUrl: 'yya8s2u.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 15,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_2',
        id: 'RRR19-5',
        imgUrl: 'yya8s2u.png',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 12, target: 42, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_2', id: 'RRR19-18', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 14, target: 42, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_2', id: 'RRR19-19', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 15, target: 42, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_2', id: 'RRR19-20', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 42, target: 61, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_2', id: 'RRR19-21', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 61, target: 77, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_2', id: 'RRR19-22', imgUrl: 'yya8s2u.png', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 144,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-3',
        imgUrl: 'RYq4EGR.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-11',
        imgUrl: 'RYq4EGR.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-20',
        imgUrl: 'RYq4EGR.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    { source: 53, target: 77, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-23', imgUrl: 'RYq4EGR.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 78, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-24', imgUrl: 'RYq4EGR.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 76, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-25', imgUrl: 'RYq4EGR.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 84, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-28', imgUrl: 'RYq4EGR.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 150,
        target: 12,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_2',
        id: 'MLG06-1',
        imgUrl: 'qXOBST8.jpg',
        cluster: 'tic3',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 12, target: 42, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_2', id: 'MLG06-4', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 42, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-8', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'intThreeLightLinkColor' },
    { source: 53, target: 76, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-10', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 77, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-12', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 78, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-14', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 82, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-16', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 53, target: 88, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-18', imgUrl: 'qXOBST8.jpg', cluster: 'tic3', color: 'repVisTechColor' },
    {
        source: 152,
        target: 0,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_1',
        id: 'WHWS12-0',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 152,
        target: 3,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_1',
        id: 'WHWS12-1',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'targetLinkColor',
        status: 'selected',
    },

    {
        source: 0,
        target: 42,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_1',
        id: 'WHWS12-16',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 3,
        target: 42,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_1',
        id: 'WHWS12-19',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 6,
        target: 42,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_1',
        id: 'WHWS12-22',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_1',
        id: 'WHWS12-25',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    { source: 60, target: 77, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-26', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 60, target: 78, value: 1, valueid: ['repf', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_1', id: 'WHWS12-27', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    {
        source: 0,
        target: 42,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-34',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 3,
        target: 42,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-35',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 6,
        target: 42,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-36',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 68,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_2',
        id: 'WHWS12-39',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },

    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_5',
        id: 'WHWS12-59',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 68,
        value: 1,
        valueid: ['repg', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_5',
        id: 'WHWS12-63',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },

    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['repea', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_6',
        id: 'WHWS12-70',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    {
        source: 42,
        target: 59,
        value: 1,
        valueid: ['repea', 'targetba'],
        paperName: 'WHWS12',
        process: 'WHWS12_6',
        id: 'WHWS12-73',
        imgUrl: 'sp1TtaX.jpg',
        cluster: 'tic3',
        color: 'intThreeLightLinkColor',
    },
    { source: 59, target: 78, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-74', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
    { source: 59, target: 80, value: 1, valueid: ['repea', 'targetba'], paperName: 'WHWS12', process: 'WHWS12_6', id: 'WHWS12-75', imgUrl: 'sp1TtaX.jpg', cluster: 'tic3', color: 'repVisVarColor' },
];
